<template>
    <b-modal v-model="mostrarModalEntrega" @show="preencher()" @hide="fecharModal()" @close="fecharModal()">
        <div slot="modal-title">
            Entrega -
            <b-badge variant="warning">{{ operacaoProp }}</b-badge>
        </div>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Nome da Entrega</label>
                    <b-input-group>
                        <b-form-input type="text" v-model="nomeEntrega"></b-form-input>
                        <b-form-invalid-feedback> O nome é Obrigatório </b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Total Previsto(Horas)</label>
                    <b-input-group>
                        <b-form-input type="number" v-model="totalPrevisto"></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Total Realizado(Horas)</label>
                    <b-input-group>
                        <b-form-input type="number" v-model="totalRealizado" disabled></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button variant="primary" :disabled="$v.$invalid" @click.stop="salvar()" class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        operacao: {
            type: String,
        },

        mostrarModal: {
            type: Boolean,
            default: () => false
        },

        entrega: {
            type: Object,
            default: () => { }
        },

        acao: {
            type: Object,
            default: () => { }
        },

        erros: {
            type: Array,
            default: () => []
        }
    },

    validations: {
        nomeEntrega: {
            required
        }
    },

    data() {
        return {
            mostrarModalEntrega: false,
            nomeEntrega: null,
            totalPrevisto: null,
            totalRealizado: null,
            IdEntrega: null,
            operacaoProp: 'INSERÇÃO'
        }
    },

    methods: {
        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar() {
            this.mostrarModalEntrega = false
            this.nomeEntrega = ""
            this.totalPrevisto = 0
            this.totalRealizado = 0
            this.IdEntrega = 0
        },

        preencher() {
            this.nomeEntrega = this.entrega.nomeEntrega
            this.totalPrevisto = this.entrega.totalPrevisto
            this.totalRealizado = this.entrega.totalRealizado
            this.IdEntrega = this.entrega.idEntrega
        },

        salvar() {
            let entregaDto = {
                nomeEntrega: this.nomeEntrega,
                totalPrevisto: this.totalPrevisto,
                idAcaoPlanoTrabalho: this.acao.idAcaoPlanoTrabalho,
                idEntrega: this.IdEntrega

            }
            this.$emit('salvar', entregaDto)
            this.resetar()
        },
    },

    watch: {
        mostrarModal() {
            this.mostrarModalEntrega = this.mostrarModal
            if (this.operacao == 'A') {
                this.operacaoProp = 'ATUALIZAÇÃO'
            }
        },
    },
}
</script>
